import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { ModalLayout } from "@appbase/templates";
import WebpartModalContent from "./WebpartModalContent.vue";

/**
 * 웹파트 추가/편집 모달
 * 웹파트의 상세 설정을 수정할 수 있다.
 */
@Component({
    components: { ModalLayout, WebpartModalContent },
})
export default class WebpartModal extends Vue {
    @Prop({ type: Object, required: true }) webpart!: webpartv3.Webpart;
    /** 관리자 페이지에서 설정한 회사 코드 */
    @Prop({ type: String, required: true }) company!: string;
    /** 웹파트 생성을 위한 모달인지 편집을 위한 모달인지 여부 */
    @Prop({ type: String, default: "new" }) mode!: "edit" | "new";
    /** 웹파트 모달 타이틀 */
    @Prop({ type: String }) title!: string;

    modalSize: string = "max-width: 600px;";

    /**
     * 저장 버튼 클릭 처리
     */
    async handleSave() {
        const { webpart } = this;
        const { isFixedSize, columns, rows, component, title, titleEn, titleCh, titleJp } = webpart;

        // 웹파트 변경사항을 저장하기 전에 유효성을 검사한다.
        let message = "";
        if (!component) message = this.$t("컴포넌트_이름이_지정되지_않았습니다").toString();
        else if (isFixedSize && (columns < 1 || rows < 1)) message = this.$t("크기는_1보다_작을수_없습니다").toString();
        else if (!title || !titleEn || !titleCh || !titleJp) message = this.$t("이름이_필요합니다").toString();
        if (message) return (window as any).alertAsync(message);

        if (await (window as any).confirmAsync(this.$t("저장_하시겠습니까").toString())) {
            // 저장 이벤트 발생
            this.$emit("save", this.webpart);
        }
    }
}
